export type Label = {
  id: string;
  name: string;
};
